import React, { useMemo } from "react";

const StartRating = ({ value = 0, count = value }: any) => {

    const totalCount = useMemo(() => {
        if (value > 0) {
            if (value % count > 0) {
                return Math.ceil(value / count) * count;
            }
            else if (value % count === 0) {
                return value;

            }
            else {
                return count;
            }
        }
        else {
            return count;
        }
    }, [value, count])

    const fullStars = Math.floor(value); // Get the number of full stars
    const hasHalfStar = value % 1 !== 0; // Check if there's a half star
    const emptyStars = totalCount - fullStars - (hasHalfStar ? 1 : 0); // Remaining empty stars

    return (
        <div>
            {/* Full Stars  */}
            {[...Array(fullStars)]?.map((_, index) => (
                <i key={index} className="fa-solid fa-star"></i>
            ))}

            {/* Half Star */}
            {hasHalfStar && <i className="fa-solid fa-star-half-stroke"></i>}

            {/* Empty Stars  */}
            {[...Array(emptyStars)]?.map((_, index) => (
                <i key={index + fullStars + 1} className="fa-regular fa-star"></i>
            ))}
        </div>
    );
};

export default StartRating;
